module.exports = __webpack_public_path__ + "static/presse1-b3368dcb7924fec614664176b8b884a1.jpg";